module.exports = __webpack_public_path__ + "img/icon_xx5.4fb463e.png";